// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRetryClaimPaymentDto
 */
export interface IRetryClaimPaymentDto {
    /**
     * 
     * @type {Set<number>}
     * @memberof IRetryClaimPaymentDto
     */
    claim_ids: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof IRetryClaimPaymentDto
     */
    payment_method_id?: number;
}

/**
 * Check if a given object implements the IRetryClaimPaymentDto interface.
 */
export function instanceOfIRetryClaimPaymentDto(value: object): value is IRetryClaimPaymentDto {
    if (!('claim_ids' in value) || value['claim_ids'] === undefined) return false;
    return true;
}

export function IRetryClaimPaymentDtoFromJSON(json: any): IRetryClaimPaymentDto {
    return IRetryClaimPaymentDtoFromJSONTyped(json, false);
}

export function IRetryClaimPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRetryClaimPaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_ids': new Set(json['claim_ids']),
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
    };
}

export function IRetryClaimPaymentDtoToJSON(json: any): IRetryClaimPaymentDto {
    return IRetryClaimPaymentDtoToJSONTyped(json, false);
}

export function IRetryClaimPaymentDtoToJSONTyped(value?: IRetryClaimPaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_ids': Array.from(value['claim_ids'] as Set<any>),
        'payment_method_id': value['payment_method_id'],
    };
}

